var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkVctIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7227_3563)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7227_3563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4609 12.2136C16.6353 11.7837 16.7236 11.3295 16.7236 10.864C16.7236 10.3984 16.6353 9.94427 16.4609 9.51431C16.4269 9.43051 16.3898 9.34832 16.3499 9.26775L15.2353 10.3823C15.229 10.3886 15.2227 10.3949 15.2161 10.4008C15.3683 11.0885 15.1773 11.8373 14.6434 12.3712L12.3713 14.6434C11.8374 15.1773 11.0885 15.3682 10.4009 15.2161C10.3949 15.2225 10.3886 15.2288 10.3823 15.2353L9.26778 16.3498C9.34836 16.3898 9.43055 16.4268 9.51435 16.4608C9.94431 16.6352 10.3984 16.7235 10.864 16.7235C11.3296 16.7235 11.7837 16.6352 12.2137 16.4608C12.6593 16.2802 13.0586 16.0151 13.4009 15.6728L15.673 13.4007C16.0151 13.0586 16.2804 12.6591 16.4611 12.2135L16.4609 12.2136ZM13.5991 8.7838C13.6051 8.77735 13.6114 8.77107 13.6177 8.76462L14.7322 7.65008C14.6516 7.61012 14.5694 7.57305 14.4856 7.53905C14.0557 7.36468 13.6015 7.27637 13.136 7.27637C12.6704 7.27637 12.2163 7.36468 11.7863 7.53905C11.3407 7.7197 10.9414 7.9848 10.5991 8.32709L8.32697 10.5992C7.98484 10.9413 7.71958 11.3408 7.53893 11.7864C7.36456 12.2164 7.27625 12.6705 7.27625 13.1361C7.27625 13.6017 7.36456 14.0558 7.53893 14.4857C7.57293 14.5695 7.60999 14.6517 7.64996 14.7323L8.7645 13.6178C8.77079 13.6115 8.77707 13.6052 8.78368 13.5992C8.63155 12.9116 8.82252 12.1627 9.35642 11.6288L11.6285 9.3567C12.1624 8.8228 12.9113 8.63183 13.599 8.78396L13.5991 8.7838Z",
    fill: "#05A660"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.21321 18.7865C4.92893 18.5022 4.92893 18.0413 5.21321 17.7571L9.05882 13.9114C9.3431 13.6272 9.804 13.6272 10.0883 13.9114C10.3725 14.1957 10.3725 14.6566 10.0883 14.9409L6.24266 18.7865C5.95838 19.0708 5.49748 19.0708 5.21321 18.7865Z",
    fill: "#57EBA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7868 5.21321C19.071 5.49748 19.071 5.95838 18.7868 6.24266L14.9411 10.0883C14.6569 10.3725 14.196 10.3725 13.9117 10.0883C13.6274 9.804 13.6274 9.34326 13.9117 9.05898L17.7573 5.21321C18.0416 4.92893 18.5025 4.92893 18.7868 5.21321Z",
    fill: "#57EBA1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7227_3563",
    x: 3.27625,
    y: 7.27637,
    width: 17.4473,
    height: 17.4473,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7227_3563"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_7227_3563",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7227_3563"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkVctIcon);
export default __webpack_public_path__ + "static/media/linkVctIcon.84a7f2a144bdda292287f26a4661ec67.svg";
export { ForwardRef as ReactComponent };